import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Probably the dumbest idea I ever had",
  "description": "",
  "published": "2016-08-02T00:00:00.000Z",
  "redirect_from": ["/blog/probably-the-dumbest-idea-i-ever-had/swizec/6887"],
  "categories": "Personal, Travel + Events",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`I ran a marathon and that was dumb. Try not to run marathons, if you can at all avoid it. They're long and they hurt and all you get in the end is a cheap piece of metal, a free banana, and some funny gifs. Anyone who tells you that marathons are rewarding and spiritual is a liar.`}</p>
    <p>{`Watch my face go from `}<em parentName="p">{`"Mum thinks you're handsome"`}</em>{` to `}<em parentName="p">{`"Light drug abuse"`}</em>{` in 4 short hours.`}</p>
    <blockquote>
      <p parentName="blockquote"><a parentName="p" {...{
          "href": "//imgur.com/c7a4j"
        }}></a></p>
    </blockquote>
    <p>{`Marathons start early. Or at least the San Francisco Marathon does because they're too cheap to keep the course open after 1pm or so.`}</p>
    <blockquote>
      <p parentName="blockquote"><a parentName="p" {...{
          "href": "//imgur.com/1ja4P"
        }}></a></p>
    </blockquote>
    <p>{`I was late, then I forgot to put on my number, then I had to run to and fro a lot to get it.`}</p>
    <blockquote>
      <p parentName="blockquote"><a parentName="p" {...{
          "href": "//imgur.com/HEFk9"
        }}></a></p>
    </blockquote>
    <p>{`Like, the start of the start line — where my bag was — and the end of the start line — where they let me into my wave — were many blocks apart. 4 blocks. I counted.`}</p>
    <blockquote>
      <p parentName="blockquote"><a parentName="p" {...{
          "href": "//imgur.com/URyrr"
        }}></a></p>
    </blockquote>
    <p>{`And because I was late, it was crowded with slow people. Spent the entire marathon passing everyone and catching up to my intended pacer. I never caught him.`}</p>
    <blockquote>
      <p parentName="blockquote"><a parentName="p" {...{
          "href": "//imgur.com/NrgR0Ez"
        }}></a></p>
    </blockquote>
    <p>{`40 minutes in.`}</p>
    <blockquote>
      <p parentName="blockquote"><a parentName="p" {...{
          "href": "//imgur.com/wjDe4"
        }}></a></p>
    </blockquote>
    <p>{`1h 20min into it. Notice how crowded the bridge got.`}</p>
    <blockquote>
      <p parentName="blockquote"><a parentName="p" {...{
          "href": "//imgur.com/HevcB"
        }}></a></p>
    </blockquote>
    <p>{`2h in, half done.`}</p>
    <blockquote>
      <p parentName="blockquote"><a parentName="p" {...{
          "href": "//imgur.com/2tziG"
        }}></a></p>
    </blockquote>
    <p>{`2h 40min is where the real race begins.`}</p>
    <blockquote>
      <p parentName="blockquote"><a parentName="p" {...{
          "href": "//imgur.com/yKhuj"
        }}></a></p>
    </blockquote>
    <p>{`You know when it feels like your muscles are tearing themselves apart? That. I think it happened on top of a steep hill or something, about 3 hours into the marathon.`}</p>
    <blockquote>
      <p parentName="blockquote"><a parentName="p" {...{
          "href": "//imgur.com/0xQxK"
        }}></a></p>
    </blockquote>
    <p>{`3h 20min ... surely I can do another 6km in 40minutes.`}</p>
    <blockquote>
      <p parentName="blockquote"><a parentName="p" {...{
          "href": "//imgur.com/IW86q"
        }}></a></p>
    </blockquote>
    <p>{`4h 2min ... this was a dumb idea.`}</p>
    <p>{`Now I have to do it all again because I missed my goal time by 2 stupid minutes. Terrible.`}</p>
    <p>{`But Sunday Me is happy that he no longer has to go on those long four hour training runs. Sleeping in here I come!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      